import { environment } from '../environments/environment';
var ɵ0 = environment.baseApi, ɵ1 = environment.linkedInAuthUrl, ɵ2 = environment.production, ɵ3 = environment.envName, ɵ4 = environment.mbdPixelUrl, ɵ5 = environment.appInsights, ɵ6 = environment.useFingerprintPro.val, ɵ7 = environment.fingerprintProKey.val, ɵ8 = environment.fpEndpoint.val, ɵ9 = environment.daysForDuidRefresh.val;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
